<template>
  <AppAlert
    :variant="alert.variant"
    :icon="alert.titleIcon || undefined"
    :title="alert.title">
    <!-- eslint-disable vue/no-v-html -->
    <span v-html="alert.body" />
    <!-- eslint-enable vue/no-v-html -->
  </AppAlert>
</template>

<script setup>
import { AppAlert } from '@/components/ui'

defineProps({
  alert: { type: Object, required: true }
})
</script>
